import React from 'react';
import SearchField from './SearchField';

interface ProductRangeToolbarProps {
  productAreas: string[]
  productAreaFilter: string
  allVisibleAreasExpanded: boolean
  setProductAreaFilter: (value: string) => void
  setFamilyFilter: (value: string) => void
  toggleAllAreas: () => void
  templateMode: boolean
  toggleTemplateMode: () => void
}

export const ProductRangeToolbar: React.FC<ProductRangeToolbarProps> = ({
  productAreas,
  productAreaFilter,
  allVisibleAreasExpanded,
  setProductAreaFilter,
  setFamilyFilter,
  toggleAllAreas,
  templateMode,
  toggleTemplateMode,
}) => (
  <div className="flex flex-col xl:flex-row xl:items-end xl:justify-between gap-4">
    <div className="flex flex-col sm:flex-row sm:items-end gap-3">
      <div className="flex flex-col gap-2 min-w-[220px]">
        <label htmlFor="product-area-filter" className="text-sm font-medium text-gray-700">Product area</label>
        <select id="product-area-filter" value={productAreaFilter} onChange={(event) => setProductAreaFilter(event.target.value)} className="rounded-lg border border-gray-300 bg-white px-4 py-2 shadow-sm focus:outline-none">
          <option value="all">All product areas</option>
          {productAreas.map((area) => <option key={area} value={area}>{area}</option>)}
        </select>
      </div>
      <div className="flex flex-col gap-2 min-w-[260px]">
        <label className="text-sm font-medium text-gray-700">Product family</label>
        <SearchField onSearch={(query) => setFamilyFilter(query)} placeholder="Search product family" autofocus={false} />
      </div>
      <button type="button" onClick={toggleAllAreas} className="rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50">
        {allVisibleAreasExpanded ? 'Collapse all' : 'Expand all'}
      </button>
      <button type="button" onClick={toggleTemplateMode} className={`rounded-md px-4 py-2 text-sm font-medium text-white ${templateMode ? 'bg-slate-700 hover:bg-slate-800' : 'bg-sky-600 hover:bg-sky-700'}`}>
        {templateMode ? 'Exit template mode' : 'Template mode'}
      </button>
    </div>
  </div>
);
